<template>
  <v-layout
    justify-center
    align-center
    fill-height
    class="login-background"
    style="
      background-image: url(/images/background/fondo.jpg);
      width: 100% !important;
      min-height: 100vh;
      background-repeat: no-repeat;
      background-position: center;
      background-size: cover;
      position: relative;
      z-index: 1;
      margin: 0 !important;
    "
  >
    <!-- Dark overlay -->
    <div class="login-overlay"></div>

    <v-container fluid fill-height text-center>
      <v-layout align-center justify-center class="login-layout-wrapper pa-3 pa-sm-6 pa-md-10">
        <v-flex xl3 lg4 md6 sm6 xs12>
          <v-card class="login-card">
            <div class="login-card-header">
              <img class="login-logo" src="/images/background/logo2.png" />
              <p class="login-subtitle">Plataforma de Análisis de Neumáticos</p>
            </div>
            <!-- <p> {{
              isRecovery ? stateObj.recovery.name : stateObj.login.name
            }}
            </p> -->

            <v-card-text class="login-card-body">
              <v-form
                ref="form"
                lazy-validation
                @submit.prevent="isRecovery ? recoveryPassword() : loginHome()"
              >
                <v-text-field
                  v-if="isRegister"
                  v-model="Empresa"
                  label="Nombre de la Empresa"
                  hide-details="auto"
                  prepend-icon="mdi-account"
                  outlined
                  dense
                  rounded
                  class="login-input"
                ></v-text-field>
                <v-text-field
                  v-if="isRegister"
                  v-model="Nombre"
                  label="Nombre del Cliente"
                  hide-details="auto"
                  prepend-icon="mdi-account"
                  outlined
                  dense
                  rounded
                  class="login-input"
                ></v-text-field>
                <v-text-field
                  v-if="isRegister"
                  v-model="Telefono"
                  label="Telefono"
                  hide-details="auto"
                  prepend-icon="mdi-phone"
                  outlined
                  dense
                  rounded
                  class="login-input"
                ></v-text-field>

                <v-text-field
                  v-if="isRegister && !isRecovery"
                  prepend-icon="mdi-email"
                  v-model="email"
                  :rules="emailRules"
                  name="email"
                  label="Email"
                  type="text"
                  placeholder="Email"
                  required
                  hide-details="auto"
                  outlined
                  dense
                  rounded
                  class="login-input"
                ></v-text-field>
                <v-text-field
                  v-if="!isRegister && !isRecovery"
                  prepend-icon="mdi-account"
                  v-model="email"
                  :rules="emailRules"
                  name="email"
                  label="Email"
                  type="text"
                  placeholder="Email"
                  required
                  hide-details="auto"
                  outlined
                  dense
                  rounded
                  class="login-input"
                ></v-text-field>

                <v-text-field
                  v-if="!isRecovery"
                  class="mt-4 login-input"
                  v-model="password"
                  prepend-icon="mdi-lock"
                  :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                  :rules="[rules.required, rules.min]"
                  :type="show1 ? 'text' : 'password'"
                  name="input-10-1"
                  label="Contraseña"
                  hint="Al menos 6 caracteres"
                  counter
                  @click:append="show1 = !show1"
                  outlined
                  dense
                  rounded
                ></v-text-field>

                <v-text-field
                  v-if="isRecovery"
                  prepend-icon="mdi-email"
                  v-model="email"
                  :rules="emailRules"
                  name="email"
                  label="Email"
                  type="text"
                  placeholder="Email"
                  required
                  hide-details="auto"
                  outlined
                  dense
                  rounded
                  class="login-input"
                ></v-text-field>
                <p v-if="isRecovery" class="mb-5 recovery-hint">
                  Ingresa tu correo electrónico para recuperar tu contraseña.
                </p>

                <v-text-field
                  v-if="isRegister"
                  prepend-icon="mdi-lock"
                  v-model="confirmPassword"
                  name="confirmPassword"
                  label="Confirmar Contraseña"
                  type="password"
                  placeholder="Confirmar Contraseña"
                  required
                  outlined
                  dense
                  rounded
                  class="login-input"
                ></v-text-field>

                <v-checkbox
                  v-if="!isRegister && !isRecovery"
                  v-model="checkboxTermConditions"
                  :rules="[rules.required]"
                  class="login-checkbox"
                >
                  <template v-slot:label>
                    <div class="checkbox-label">
                      He leído y acepto los
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            href="#"
                            @click.prevent.stop="dialogTerminos = true"
                            v-on="on"
                            class="terms-link"
                          >
                            Términos y Condiciones
                          </a>
                        </template>
                        Ver Términos y Condiciones
                      </v-tooltip>
                    </div>
                  </template>
                </v-checkbox>
                <v-checkbox
                  v-if="isRegister"
                  v-model="checkbox"
                  class="login-checkbox"
                >
                  <template v-slot:label>
                    <div class="checkbox-label">
                      He leído y acepto los
                      <v-tooltip bottom>
                        <template v-slot:activator="{ on }">
                          <a
                            href="#"
                            @click.prevent.stop="dialogTerminos = true"
                            v-on="on"
                            class="terms-link"
                          >
                            Términos y Condiciones
                          </a>
                        </template>
                        Ver Términos y Condiciones
                      </v-tooltip>
                      ***
                    </div>
                  </template>
                </v-checkbox>
                <div v-if="errorMessage" class="error-alert mb-4">
                  <v-icon small color="#d32f2f" class="mr-1"
                    >mdi-alert-circle</v-icon
                  >
                  {{ errorMessage }}
                </div>
                <v-btn
                  :loading="loading"
                  :disabled="!valid"
                  dark
                  type="submit"
                  block
                  large
                  class="login-submit-btn mb-4"
                  value="log in"
                  submit
                >
                  <v-icon left small>{{
                    isRecovery ? "mdi-email-send" : "mdi-login-variant"
                  }}</v-icon>
                  {{
                    isRecovery
                      ? stateObj.recovery.namebtn
                      : stateObj.login.namebtn
                  }}
                </v-btn>
                <!-- <v-btn :loading="loading" :disabled="!valid" dark type="submit" class="mb-5" color="error" value="log in"
                  submit>{{
                    isRegister
                    ? stateObj.register.namebtn
                    : isResetPass
                    ? stateObj.resetpass.namebtn
                    : stateObj.login.namebtn
                  }}</v-btn> -->

                <!-- <div class="grey--text mt-4" color="blue accent-4" v-on:click="isRegister = !isRegister;">
                        {{toggleMessage}}  
                      </div> -->
                <div v-if="!isRecovery" class="pa-2 login-links">
                  ¿Olvidaste tu
                  <!-- <a color="blue accent-4" @click="insertarRuta('/resetpassword')"> -->
                  <a class="link-action" @click="cambioRecovery()">
                    contraseña</a
                  >?

                  <br />
                  <!-- ¿Aun no tienes una cuenta?
                  <a color="blue accent-4" @click="CambioPantalla()">
                    Registrate
                  </a>
                  <br> -->
                </div>
                <!-- <div v-else class="pa-2">
                  <a color="blue accent-4" @click="CambioPantalla()">
                    ¿Ya tienes una cuenta?
                  </a>
                </div> -->
                <div v-else class="pa-2 login-links">
                  ¿Ya tienes una cuenta?
                  <a class="link-action" @click="cambioRecovery()">
                    Iniciar sesión
                  </a>
                </div>
              </v-form>
            </v-card-text>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>

    <!-- Snackbar Alert (Top-Right of screen) -->
    <MensajeTransicion
      :color="mensajeColor"
      :text="mensaje"
      v-if="verAlerta"
      :top="true"
      :bottom="false"
    />

    <!-- Version & Copyright in the bottom center of the web -->
    <div class="login-footer">
      <p class="version-label">
        Tiresoft.pe versión {{ appVersion }} ({{ appDate }})
      </p>
      <p class="copyright-label">
        © 2018-{{ currentYear }} Mandril S.A.C., colaboradora de
        <!-- a href="https://reencauchadoraelsol.com" target="_blank">Reencauchadora El Sol</a -->
        <a href="https://tiresol.com.pe" target="_blank">Tiresol</a><br>
        Desarrollado por <a href="https://contentmedia.pe" target="_blank">Content Media</a>
      </p>
    </div>

    <v-dialog v-model="dialog" persistent max-width="600px">
      <v-form ref="form" lazy-validation @submit.prevent="updatePassword()">
        <v-card class="dialog-card">
          <v-card-title class="dialog-header">
            <v-icon left color="white" small>mdi-lock-reset</v-icon>
            <span class="text-h6">Actualizar Contraseña</span>
          </v-card-title>
          <v-card-text>
            <p class="mb-5 dialog-info-banner">
              Por favor, revise su buzón de correo o la carpeta de spam para
              encontrar el token de recuperación.
            </p>
            <v-text-field
              label="Email"
              hide-details="auto"
              prepend-icon="mdi-email"
              v-model="email"
              readonly
              outlined
              dense
              rounded
              class="login-input"
            ></v-text-field>

            <v-text-field
              name="r_token"
              v-model="r_token"
              label="Token"
              hide-details="auto"
              prepend-icon="mdi-key"
              outlined
              dense
              rounded
              class="login-input mt-3"
            ></v-text-field>
            <br />
            <v-text-field
              name="r_password"
              v-model="r_password"
              prepend-icon="mdi-lock"
              :rules="[rules.required, rules.min]"
              :type="show1 ? 'text' : 'password'"
              label="Contraseña"
              hint="Al menos 6 caracteres"
              counter
              @click:append="show1 = !show1"
              outlined
              dense
              rounded
              class="login-input"
            ></v-text-field>

            <v-text-field
              name="r_confirmPassword"
              v-model="r_confirmPassword"
              prepend-icon="mdi-lock"
              :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
              :rules="[rules.required, rules.min]"
              :type="show1 ? 'text' : 'password'"
              label="Repitar Contraseña"
              hint="Al menos 6 caracteres"
              counter
              @click:append="show1 = !show1"
              outlined
              dense
              rounded
              class="login-input"
            ></v-text-field>

            <div v-if="errorMessage" class="error-alert text-center mb-4">
              <v-icon small color="#d32f2f" class="mr-1"
                >mdi-alert-circle</v-icon
              >
              {{ errorMessage }}
            </div>
          </v-card-text>
          <v-card-actions class="dialog-actions">
            <v-spacer></v-spacer>
            <v-btn text class="dialog-btn-cancel" @click="cerrarDialogo()">
              Cerrar
            </v-btn>
            <v-btn
              :loading="loading"
              :disabled="!valid"
              dark
              type="submit"
              class="dialog-btn-save"
              submit
            >
              <v-icon left small>mdi-content-save</v-icon>
              Guardar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>

    <!-- Dialog Modal Términos y Condiciones -->
    <v-dialog v-model="dialogTerminos" max-width="850px" scrollable>
      <v-card class="dialog-card terms-dialog-card">
        <v-card-title
          class="dialog-header d-flex justify-space-between align-center"
        >
          <div class="d-flex align-center">
            <v-icon left color="white" small>mdi-file-document-outline</v-icon>
            <span class="text-h6 white--text">Términos y Condiciones</span>
          </div>
          <v-btn icon dark small @click="dialogTerminos = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pa-0 terms-dialog-body">
          <iframe
            src="/docs/terminos-y-condiciones.pdf#toolbar=1&navpanes=0"
            width="100%"
            height="850px"
            frameborder="0"
            class="terms-pdf-frame"
          ></iframe>
        </v-card-text>
        <v-card-actions class="dialog-actions">
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="dialog-btn-save"
            @click="aceptarTerminos()"
          >
            <v-icon left small>mdi-check</v-icon>
            Aceptar&nbsp;&nbsp;&nbsp;
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-layout>
</template>
<script>
import { mapActions } from "vuex";
import MensajeTransicion from "@/components/Alerta.vue";
import Swal from "sweetalert2";
import router from "@/router";
import global from "@/global";

export default {
  name: "App",
  components: {
    MensajeTransicion,
  },
  data() {
    return {
      loading: false,
      valid: true,
      checkbox: true,
      checkboxTermConditions: false,
      username: "",
      confirmPassword: "",
      isRegister: false,
      isRecovery: false,
      errorMessage: "",
      stateObj: {
        register: {
          name: "Registrar Usuario",
          namebtn: "Registrar",
          message: "¿Ya tienes una cuenta?",
        },
        login: {
          name: "",
          namebtn: "Ingresar",
          message: "¿Ahún no tienes una cuenta ? Registrate",
        },
        recovery: {
          name: "Recuperar Contraseña",
          namebtn: "Enviar",
          message: "¿Ya tienes una cuenta?",
        },
      },
      valid: true,
      email: "",
      emailRules: [
        (v) => !!v || "Campo requerido.",
        (v) => /.+@.+\..+/.test(v) || "Campo no valido",
      ],
      show1: false,
      password: "",
      rules: {
        required: (v) => !!v || "Campo requerido.",
        min: (v) => v.length >= 6 || "Min 6 characters",
      },
      Empresa: "",
      Nombre: "",
      Telefono: "",
      verAlerta: false,
      mensaje: "",
      dialog: false,
      dialogTerminos: false,
      r_token: "",
      r_password: "",
      r_confirmPassword: "",
      mensajeColor: "#FA694A",
      appVersion: global.app_version,
      appDate: global.app_build_date,
    };
  },
  created() {},
  methods: {
    insertarRuta(param) {
      router.push(param);
    },
    async ressetpass() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        const data = { email: this.email };
        const response = await this.ressetpass(data);

        if (!response.status) {
          this.loading = false;
          this.mensaje = response.message;
          this.verAlerta = true;
          setTimeout(() => [(this.verAlerta = false)], 4000);
        }
      }
    },
    register() {
      if (this.password == this.confirmPassword) {
        if (this.$refs.form.validate()) {
          const data = {
            Empresa: this.Empresa,
            name: this.Nombre,
            Telefono: this.Telefono,
            email: this.email,
            password: this.password,
          };
          this.registrocliente(data);
        }
      } else {
        this.errorMessage = "Las contraseñas no coinciden";
      }
    },
    async recoveryPassword() {
      if (this.$refs.form.validate()) {
        this.loading = true;
        const data = { email: this.email };
        const response = await this.sendRecoveryPassword(data);
        if (response.status) {
          this.loading = false;
          this.mensaje = response.message;
          this.verAlerta = true;
          setTimeout(() => [(this.verAlerta = false)], 4000);
          this.dialog = true;
          this.errorMessage = "";
          this.mensajeColor = "#4CAF50";
        } else {
          this.loading = false;
          this.errorMessage = "Upps Algo Paso!";
        }
      } else {
        this.errorMessage = "Por favor ingrese su correo!";
      }
    },
    async loginHome() {
      if (this.$refs.form.validate()) {
        this.loading = true;

        const data = { email: this.email, password: this.password };
        const response = await this.login(data);

        if (!response.status) {
          this.loading = false;
          this.mensaje = response.message;
          this.verAlerta = true;
          setTimeout(() => [(this.verAlerta = false)], 4000);
          this.mensajeColor = "#FA694A";
        }
      }
    },
    CambioPantalla(param) {
      if (param == 2) {
        this.isRegister = false;
        this.isResetPass = true;
      } else if (param == 1) {
        this.isRegister = true;
        this.isResetPass = false;
      } else {
        this.isRegister = false;
        this.isResetPass = false;
      }
      this.$refs.form.resetValidation();
    },
    cambioRecovery() {
      this.isRecovery = !this.isRecovery;
    },
    async updatePassword() {
      this.loading = true;

      if (this.r_password == this.r_confirmPassword) {
        const data = {
          email: this.email,
          token_password: this.r_token,
          new_password: this.r_password,
        };
        const response = await this.updateRecoveryPassword(data);

        if (response.status) {
          this.loading = false;
          this.mensaje = response.message;
          this.verAlerta = true;
          setTimeout(() => {
            this.verAlerta = false;
          }, 4000); // Espera a que se muestre el mensaje antes de redirigir
          this.dialog = false;
          this.errorMessage = "";
          this.isRegister = false;
          this.isRecovery = false;
          this.mensajeColor = "#4CAF50";
        } else {
          this.loading = false;
          this.errorMessage = "¡Upps! Algo pasó.";
        }
      } else {
        this.loading = false;
        this.errorMessage = "Las contraseñas no coinciden";
      }
    },
    cerrarDialogo(valor = false) {
      this.dialog = false;
    },
    aceptarTerminos() {
      this.checkboxTermConditions = true;
      this.checkbox = true;
      this.dialogTerminos = false;
    },
    ...mapActions("login", [
      "mockLogin",
      "registrocliente",
      "login",
      "sendRecoveryPassword",
      "updateRecoveryPassword",
    ]),
  },
  computed: {
    currentYear: function () {
      return new Date().getFullYear();
    },
    toggleMessage: function () {
      return this.isRegister
        ? this.stateObj.register.message
        : this.stateObj.login.message;
    },
  },
};
</script>

<style scoped>
/* ===== Dark Overlay ===== */
.login-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: radial-gradient(
      circle at center,
      rgba(15, 23, 42, 0.45) 0%,
      rgba(10, 15, 30, 0.75) 100%
    ),
    linear-gradient(135deg, rgba(0, 0, 0, 0.5) 0%, rgba(15, 23, 42, 0.6) 100%);
  z-index: 0;
}

/* ===== Card ===== */
.login-card {
  max-width: 440px;
  margin: 0 auto;
  border-radius: 20px !important;
  background: #ffffff !important;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.25) !important;
  padding: 32px 28px 20px !important;
  position: relative;
  z-index: 1;
  overflow: hidden;
}

.login-card::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  height: 4px;
  background: linear-gradient(90deg, #c62828 0%, #e53935 50%, #ff5252 100%);
  border-top-left-radius: 20px;
  border-top-right-radius: 20px;
}

/* ===== Card Header ===== */
.login-card-header {
  text-align: center;
  margin-bottom: 8px;
}

.login-logo {
  width: 160px;
  margin-bottom: 8px;
  transition: transform 0.3s ease;
}

.login-logo:hover {
  transform: scale(1.05);
}

.login-subtitle {
  color: #78909c;
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 0;
}

/* ===== Card Body ===== */
.login-card-body {
  padding: 16px 8px 8px !important;
}

/* ===== Input Fields ===== */
.login-input {
  margin-bottom: 4px;
}

.login-input >>> .v-input__slot {
  min-height: 44px !important;
  background: #f8f9fa !important;
  transition: all 0.25s ease !important;
}

.login-input >>> .v-input__slot:hover {
  background: #f1f3f5 !important;
}

.login-input >>> fieldset {
  border-color: #e0e0e0 !important;
  transition: border-color 0.25s ease !important;
}

.login-input >>> .v-input--is-focused fieldset {
  border-color: #c62828 !important;
  border-width: 2px !important;
}

.login-input >>> .v-label {
  font-size: 13px !important;
  color: #78909c !important;
}

.login-input >>> .v-label--active {
  color: #c62828 !important;
}

.login-input >>> .v-icon {
  color: #90a4ae !important;
  font-size: 20px !important;
}

.login-input >>> .v-input--is-focused .v-icon {
  color: #c62828 !important;
}

.login-input >>> input {
  font-size: 14px !important;
}

/* ===== Checkbox ===== */
.login-checkbox {
  margin-top: 0 !important;
  padding-top: 0 !important;
}

.checkbox-label {
  font-size: 12px;
  color: #607d8b;
}

.terms-link {
  color: #1565c0 !important;
  text-decoration: none;
  font-weight: 500;
}

.terms-link:hover {
  text-decoration: underline;
}

/* ===== Error Alert ===== */
.error-alert {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 13px;
  color: #d32f2f;
  background: #ffebee;
  border: 1px solid #ffcdd2;
  border-radius: 10px;
  padding: 8px 14px;
  animation: shake 0.4s ease;
}

@keyframes shake {
  0%,
  100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-5px);
  }
  75% {
    transform: translateX(5px);
  }
}

/* ===== Submit Button ===== */
.login-submit-btn {
  background: linear-gradient(135deg, #c62828 0%, #e53935 100%) !important;
  color: #ffffff !important;
  border-radius: 12px !important;
  height: 46px !important;
  font-weight: 600 !important;
  font-size: 14px !important;
  letter-spacing: 0.5px !important;
  text-transform: none !important;
  box-shadow: 0 6px 20px rgba(198, 40, 40, 0.35) !important;
  transition: all 0.3s ease !important;
}

.login-submit-btn:hover {
  box-shadow: 0 8px 28px rgba(198, 40, 40, 0.5) !important;
  transform: translateY(-1px);
}

.login-submit-btn:active {
  transform: translateY(0);
}

.login-submit-btn.v-btn--disabled {
  background: #e0e0e0 !important;
  color: #9e9e9e !important;
  box-shadow: none !important;
}

/* ===== Recovery Hint ===== */
.recovery-hint {
  text-align: center;
  font-size: 12px;
  color: #42a5f5;
  background: #e3f2fd;
  border-radius: 8px;
  padding: 8px 12px;
}

/* ===== Links ===== */
.login-links {
  font-size: 13px;
  color: #78909c;
}

.link-action {
  color: #1565c0 !important;
  cursor: pointer;
  font-weight: 500;
  text-decoration: none;
  transition: color 0.2s ease;
}

.link-action:hover {
  color: #0d47a1 !important;
  text-decoration: underline;
}

/* ===== Login Footer ===== */
.login-footer {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  text-align: center;
  z-index: 2;
  padding: 0 16px;
}

.version-label {
  color: rgba(255, 255, 255, 0.65);
  font-size: 12px;
  margin-bottom: 2px;
  letter-spacing: 0.4px;
  font-weight: 500;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
}

.copyright-label {
  color: rgba(255, 255, 255, 0.5);
  font-size: 11px;
  letter-spacing: 0.3px;
  font-weight: 400;
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.6);
}

/* ===== Dialog ===== */
.dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
}

.dialog-header {
  background: linear-gradient(135deg, #c62828 0%, #e53935 100%);
  color: #ffffff !important;
  padding: 16px 20px !important;
}

.dialog-header .text-h6 {
  color: #ffffff !important;
  font-weight: 600 !important;
}

.dialog-info-banner {
  text-align: center;
  font-size: 12px;
  color: #1565c0;
  background: #e3f2fd;
  border-radius: 8px;
  padding: 10px 14px;
  border: 1px solid #bbdefb;
}

.dialog-actions {
  padding: 12px 20px 16px !important;
}

.dialog-btn-cancel {
  color: #78909c !important;
  text-transform: none !important;
  font-weight: 500 !important;
}

.dialog-btn-save {
  background: linear-gradient(135deg, #1565c0 0%, #1976d2 100%) !important;
  color: #ffffff !important;
  text-transform: none !important;
  font-weight: 600 !important;
  border-radius: 10px !important;
  box-shadow: 0 4px 12px rgba(21, 101, 192, 0.3) !important;
}

/* ===== Terms Dialog ===== */
.terms-dialog-card {
  border-radius: 16px !important;
}

.terms-dialog-body {
  background: #f1f3f5;
}

.terms-pdf-frame {
  display: block;
  width: 100%;
  border: none;
}

/* ===== Responsive ===== */
@media (max-width: 600px) {
  .login-card {
    padding: 20px 16px 12px !important;
    border-radius: 16px !important;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2) !important;
    width: 100% !important;
    max-width: 100% !important;
  }

  .login-card-header {
    margin-bottom: 4px !important;
  }

  .login-logo {
    width: 125px !important;
    margin-bottom: 4px !important;
  }

  .login-subtitle {
    font-size: 10.5px !important;
    letter-spacing: 0.3px !important;
  }

  .login-card-body {
    padding: 8px 0 4px !important;
  }

  .login-input {
    margin-bottom: 2px !important;
  }

  .login-input >>> .v-input__slot {
    min-height: 38px !important;
    height: 38px !important;
    border-radius: 19px !important;
    padding: 0 12px !important;
  }

  .login-input >>> input {
    font-size: 12.5px !important;
  }

  .login-input >>> .v-label {
    font-size: 11.5px !important;
    top: 9px !important;
  }

  .login-input >>> .v-label--active {
    font-size: 10px !important;
    top: 18px !important;
  }

  .login-input >>> .v-icon {
    font-size: 18px !important;
  }

  .login-input >>> .v-input__prepend-outer {
    margin-top: 6px !important;
    margin-right: 6px !important;
    margin-left: 0 !important;
  }

  .login-input >>> .v-input__append-inner {
    margin-top: 6px !important;
  }

  .login-input.mt-4 {
    margin-top: 8px !important;
  }

  .login-input >>> .v-text-field__details {
    min-height: 16px !important;
    margin-bottom: 2px !important;
    padding: 0 8px !important;
  }

  .login-input >>> .v-messages__message {
    font-size: 10px !important;
    line-height: 12px !important;
  }

  .login-checkbox {
    margin-top: 2px !important;
    margin-bottom: 4px !important;
  }

  .login-checkbox >>> .v-input--selection-controls__input {
    margin-right: 6px !important;
    width: 20px !important;
    height: 20px !important;
  }

  .login-checkbox >>> .v-icon {
    font-size: 18px !important;
  }

  .checkbox-label {
    font-size: 11px !important;
    line-height: 1.3 !important;
    text-align: left !important;
  }

  .terms-link {
    font-size: 11px !important;
  }

  .error-alert {
    font-size: 11.5px !important;
    padding: 6px 10px !important;
    margin-bottom: 10px !important;
    border-radius: 8px !important;
  }

  .error-alert >>> .v-icon {
    font-size: 15px !important;
  }

  .recovery-hint {
    font-size: 11px !important;
    padding: 6px 10px !important;
    margin-bottom: 10px !important;
  }

  .login-submit-btn {
    height: 38px !important;
    font-size: 12.5px !important;
    border-radius: 10px !important;
    margin-bottom: 10px !important;
  }

  .login-submit-btn >>> .v-icon {
    font-size: 16px !important;
  }

  .login-links {
    font-size: 11.5px !important;
    padding: 4px 0 !important;
    line-height: 1.4 !important;
  }

  .link-action {
    font-size: 11.5px !important;
  }

  .login-footer {
    bottom: 8px !important;
    padding: 0 8px !important;
  }

  .version-label {
    font-size: 10px !important;
  }

  .copyright-label {
    font-size: 9px !important;
  }
}

@media (max-width: 360px) {
  .login-card {
    padding: 16px 12px 10px !important;
  }

  .login-logo {
    width: 110px !important;
  }

  .login-subtitle {
    font-size: 9.5px !important;
  }

  .login-input >>> .v-input__slot {
    min-height: 36px !important;
    height: 36px !important;
  }

  .login-submit-btn {
    height: 36px !important;
    font-size: 12px !important;
  }
}
</style>
